import styles from '../ScenarioGenerator.module.css';
import { Tooltip } from '../../../common/Tooltip';
import { VideoGenerationSettings } from '../VideoGenerationSettings';
import type { SetupPanelProps } from '../SetupPanel';
import { useScenarioSetup } from '../hooks/ScenarioSetupContext';

export function VideoSettingsSection(props: SetupPanelProps) {
  const { accordions } = props;

  const {
    videoGenerationMode,
    videoSettingsSummaryScenario,
    videoSettings, setVideoSettings,
    isMotionEngine,
  } = useScenarioSetup();

  const {
    isVideoSettingsOpen, setIsVideoSettingsOpen } = accordions;

  return (
    <>
        <div className={`accordion-section ${isVideoSettingsOpen ? 'accordion-section-open' : ''}`}>
          <button
            type="button"
            className="accordion-header"
            onClick={() => setIsVideoSettingsOpen(!isVideoSettingsOpen)}
            aria-expanded={isVideoSettingsOpen}
          >
            <span className="accordion-title">
              <img src="/movies_reel.svg" alt="" className="accordion-title-icon" />
              <span>動画生成設定</span>
              <span className="accordion-summary">{videoSettingsSummaryScenario}</span>
            </span>
            <span className={`accordion-icon ${isVideoSettingsOpen ? 'accordion-icon-open' : ''}`}>
              <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor" style={{ transition: 'transform 0.2s', transform: isVideoSettingsOpen ? 'rotate(90deg)' : 'none' }}><path d="M2 0l4 4-4 4z" /></svg>
            </span>
          </button>
          <div className={`accordion-panel ${isVideoSettingsOpen ? 'accordion-panel-open' : 'accordion-panel-closed'}`}>
            <VideoGenerationSettings
              settings={videoSettings}
              onSettingsChange={setVideoSettings}
              showResizeMode={videoGenerationMode === 'frame'}
              isScenarioMode={true}
              motionEngine={!!isMotionEngine}
              requireReferenceSupport={videoGenerationMode === 'reference' || videoGenerationMode === 'storyboard'}
              referenceModeLabel={videoGenerationMode === 'storyboard' ? 'ストーリーボード' : 'AIおまかせ'}
            />
            {/* 「すべてのナレーションを自動生成」チェックは非表示にした (2026-09-09)。
                標準フローはシナリオ末尾の「ナレーション」セクションの「すべてのナレーションを生成」。
                state (autoGenerateNarration) と自動生成の配線は残しているが、常に false で動く。 */}
            <div className={styles.accordionPanelFooter}>
              <Tooltip content="閉じる">
                <button type="button" className={styles.iconButton} onClick={() => setIsVideoSettingsOpen(false)}>
                  <img src="/move_collapse_vertical.svg" alt="閉じる" style={{ width: '16px', height: '16px' }} />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
    </>
  );
}
